// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3MCDN","empty":"ModalGraph_empty__30osv"};